import { useState, useEffect } from 'react';
import { supabase } from '../../supabase';

export default function useActivityLog(count = 10) {
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('activity_log')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(count)
      .then(({ data }) => {
        setActivity(data || []);
        setLoading(false);
      });

    const channel = supabase
      .channel('activity-log-changes')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'activity_log' }, (payload) => {
        setActivity(prev => [payload.new, ...prev].slice(0, count));
      })
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, [count]);

  return { activity, loading };
}
